import { useMemo } from 'react'

import { form } from '../../formState'

import { currencies } from '../../../currencies'
import type { CurrencyOption } from '../../typings'

import { createValidateCurrency } from './hooks/createValidateCurrency'
import { useTexts } from './hooks/useTexts'

export function Currency() {
  const texts = useTexts()

  const items = useMemo<CurrencyOption[]>(
    () =>
      currencies.map(value => ({
        label: value,
        value,
      })),
    [],
  )

  form.useAddFieldValidation<'currency'>('currency', async (field, _formApi) => {
    const currencyValidation = await createValidateCurrency(texts, field.value)

    return (
      currencyValidation.currencyRequiredError?.message ||
      currencyValidation.currencyValidError?.message
    )
  })

  return (
    <form.SimpleSelect
      selectProps={{
        label: texts.currency,
      }}
      label={texts.currency}
      options={items}
      validateOn="focus blur change"
      testId="currency"
      name="currency"
    />
  )
}
